import strIncludes from './strIncludes';

const style = document.documentElement.style;
const ua = navigator.userAgent;

const detections = {
  // put in browser stats order: our most popular browser first
  isEmbedded: {
    className: 'browser-is-embedded',
    predicate: () => strIncludes(window.location.pathname, '/embed'),
    continue: true,
  },
  supportsTouch: {
    className: 'browser-supports-touch',
    predicate: () => 'ontouchstart' in window,
    continue: true,
  },
  isIos: {
    className: 'browser-ios',
    predicate: () => 'webkitOverflowScrolling' in style,
    continue: true,
  },
  isIphone: {
    className: 'browser-iphone',
    predicate: () => (strIncludes(ua, 'iphone') || strIncludes(ua, 'ipod')) && detections.isIos.predicate(),
  },
  isIpad: {
    className: 'browser-ipad',
    predicate: () => strIncludes(ua, 'ipad') && detections.isIos.predicate(),
  },
  isWindows: {
    className: 'browser-windows',
    predicate: () => strIncludes(ua, 'windows'),
    continue: true,
  },
  isIe: {
    className: 'browser-ie',
    predicate: () => ('msScrollLimit' in style || 'behavior' in style) && !('webkitFlex' in style),
  },
  // isEdge: {
  //   className: 'browser-edge',
  //   predicate: () => !!(window.CSS && window.CSS.supports('-ms-user-select', 'none')),
  // },
  // isSafari: {
  //   className: 'browser-safari',
  //   predicate: () => 'WebkitDashboardRegion' in style,
  // },
  isAndroid: {
    className: 'browser-android',
    predicate: () => strIncludes(ua, 'android') && 'WebkitAppearance' in style,
    continue: true,
  },
  isFirefox: {
    className: 'browser-firefox',
    predicate: () => 'MozAppearance' in style,
  },
};

let stopChecking;

const results = Object.keys(detections).reduce((obj, key) => {
  if (stopChecking) {
    obj[key] = false;
  }
  else {
    obj[key] = detections[key].predicate();

    if (obj[key]) {
      document.documentElement.classList.add(detections[key].className);

      if (!detections[key].continue) {
        stopChecking = true;
      }
    }
  }

  return obj;
}, {});

export default results;
